var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PlotViewer"},[(_vm.isLoaded && _vm.plots.length < 1)?_c('Modal',[_c('Notice',{staticClass:"warning"},[_vm._v(" "+_vm._s(_vm.$t('notFound'))+" ")])],1):_vm._e(),_c('GmapMap',{ref:"map",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"google-map","center":_vm.center,"mapTypeId":"hybrid","options":{
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControl: false,
      },"zoom":7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }